import api from './api';

export interface KeywordRanking {
  id: number;
  keyword: string;
  currentPosition: number;
  previousPosition: number;
  searchVolume: number;
  url: string;
  device: string;
  country: string;
  history: Record<string, number>;
}

export interface PageSpeedData {
  performance: number;
  accessibility: number;
  bestPractices: number;
  seo: number;
  fcp: number;     // First Contentful Paint (ms)
  lcp: number;     // Largest Contentful Paint (ms)
  cls: number;     // Cumulative Layout Shift
  tbt: number;     // Total Blocking Time (ms)
  speedIndex: number;
  fetchedAt: string;
}

export const seoService = {
  getKeywords: async (websiteId: string) => {
    const response = await api.get(`/api/websites/${websiteId}/seo/keywords`);
    return response.data.data as KeywordRanking[];
  },

  getPageSpeed: async (websiteId: string) => {
    const response = await api.get(`/api/websites/${websiteId}/seo/pagespeed`);
    return response.data.data as PageSpeedData;
  },

  refreshKeywords: async (websiteId: string) => {
    const response = await api.post(`/api/websites/${websiteId}/seo/keywords/refresh`);
    return response.data;
  },

  clearPageSpeedCache: async (websiteId: string) => {
    const response = await api.post(`/api/websites/${websiteId}/seo/pagespeed/clear-cache`);
    return response.data;
  },
};
